import { render, staticRenderFns } from "./TalentIndex.vue?vue&type=template&id=6d8fdcc7&"
import script from "./TalentIndex.vue?vue&type=script&lang=js&"
export * from "./TalentIndex.vue?vue&type=script&lang=js&"
import style0 from "./TalentIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports